<div oui-dialog-title>
  Historique de l'opération
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>
<div class="filter">
  <oui-select-filter
    type="list"
    label="Filtrer par évènement"
    [listOptions]="options"
  [control]="control"></oui-select-filter>

  <oui-chip-list type="selection" [noWrap]="false">
    @for (chip of control.value; track chip) {
      <oui-chip (remove)="onRemoveChip(chip)">{{ chip }}</oui-chip>
    }
  </oui-chip-list>
</div>

<oui-dialog-content [scroll]="true">
  @if (isloading) {
    <div class="loading-container">
      <oui-loading size="small"></oui-loading>
    </div>
  }

  @if (historyDisplayedEntries) {
    <lib-history
      [records]="filteredEntries"
      (documentOpen)="this.documentOpen.emit($event)"
    (bordereauLink)="onBordereauLink($event)"></lib-history>
  }
</oui-dialog-content>
